var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-loading-card container-lg bg-white text-center d-flex justify-content-center align-items-center p-0",class:{border: _vm.hasBorder}},[_vm._m(0),_c('span',{staticClass:"ml-4"},[_vm._v(_vm._s(_vm.$t('載入中')))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"loading-spinner m-0"},[_c('span',{staticClass:"icon-Loading"})])
}]

export { render, staticRenderFns }